export default "__VITE_ASSET__BovxN67J__"